export default function handleMartynaWorldRedirectPopup() {
  const popup = document.querySelector(".js-popup-martyna-world-redirect");
  const closeButtons = popup.querySelectorAll(".js-popup-close");
  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      popup.classList.remove("is-open");
    });
  });
}
